module.exports = __webpack_public_path__ + "static/media/verification2.21fc1a91.png";